import React, {Fragment, useEffect, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import { translateRecord } from '../../../common/utils';
import {ReactComponent as DropDown} from "../../../../icons/dropdown-down.svg";
import {Collapse} from "react-bootstrap";
import Category from "./Category";
import {useDispatch, useSelector} from "react-redux";
import {removeCategoryDishesAction, removeOrderDishesAction} from "../../../../store/actions/OrdersActions";
import Logo2 from "../../../../images/logo2.png";

const EmojiView = (props) => {
  const storeOrders = useSelector(store => store.orders);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const refs = useRef({});
  const stickyRefs = useRef({});
  const hiddenCategoryRefs = useRef({});

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  const isSticky = () => {
    Object.entries(stickyRefs.current).forEach(([categoryType, stickyElement]) => {
      const hiddenElement = hiddenCategoryRefs.current[categoryType];
      const scrollTop = window.scrollY;
      const isCurrentActive = categoryType === `${props.activeCategory}`;
      if (!!stickyElement) {
        if (isCurrentActive && !!hiddenElement) {
          const stickyTopPosition = hiddenElement.offsetTop - (!!props.company ? 228 : 85);
          if (scrollTop > stickyTopPosition) {
            hiddenElement.style.height = '40px';
            stickyElement.classList.add('is-sticky');
            if (!!props.company) {
              stickyElement.style.top = '227px';
            }
          } else {
            hiddenElement.style.height = '0';
            stickyElement.classList.remove('is-sticky');
          }
        } else {
          if (!!hiddenElement) {
            hiddenElement.style.height = '0';
          }
          stickyElement.classList.remove('is-sticky');
        }
      }
    });
  };

  function working_time(category) {
    if (!category.working_hours.default) {
      if (isHoliday(category)) {
        return t('holiday');
      } else {
        return `${getTime(category.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].start_time)} - ${getTime(category.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].end_time)}`
      }
    }
  }

  function getTime(time) {
    return time.split(' ')[1];
  }

  function isHoliday(category) {
    return !!category.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].holiday;
  }

  function removeCategoryDishes(categoryId) {
    let newCategoryDishes = {};
    Object.values(storeOrders.orderDishes[props.slug].dishes).filter((d) => d.category_dish_id !== categoryId).map((d) =>
      newCategoryDishes[d.id] = d
    );
    if (Object.keys(newCategoryDishes).length > 0) {
      dispatch(removeCategoryDishesAction(props.slug, newCategoryDishes));
    } else {
      dispatch(removeOrderDishesAction(props.slug));
    }
  }

  return (
    <div>
      { props.menu.map((dish, i) =>
        <Fragment key={i}>
          <div className='mb-1' key={i} ref={(el) => {refs.current[dish.id] = el}}>
            <div style={{height: 0}} ref={(element) => {hiddenCategoryRefs.current[dish.id] = element}}/>
            <div
              ref={(element) => {stickyRefs.current[dish.id] = element}}
              className={`${props.activeCategory === dish.id && 'primary-background'} menu-category`}
              onClick={() => props.getCategoryDishes(dish)}
              style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 2, zIndex: 3}}
            >
              <div className='d-flex' style={{alignItems: "center"}}>
                { !!dish.emoji ?
                  <span className='emoji mr-2' role="img" aria-label={'label'}
                        style={{background: props.activeCategory === dish.id && 'white'}}
                  >
                    {String.fromCodePoint(...dish.emoji.split(','))}
                  </span>
                :
                  <img className="emoji mr-2" src={Logo2} alt="logo2"/>}
                <h6 className='fs-16 mb-0 mr-1' style={{lineHeight: 1, textAlign: 'left',
                  color: props.activeCategory === dish.id && 'white'}}
                >
                  {translateRecord(dish, 'content')}
                </h6>
                { !!dish.price &&
                  <p className='mb-0 ml-2' style={{lineHeight: 1, textAlign: 'left',
                    color: props.activeCategory === dish.id && 'white'}}
                  >
                    <span>{dish.price}</span><small>₴</small>
                  </p>}
              </div>
              <div className='d-flex align-items-center justify-content-end position-relative' style={{minWidth: '85px'}}>
                { props.selectedDishesCount(dish) > 0 &&
                  <span className='selected-dishes fs-16' style={{lineHeight: 1.5, right: -20, top: -22}}>
                    {props.selectedDishesCount(dish)}
                    <span className='text-black fs-12' onClick={() => removeCategoryDishes(dish.id)}
                          style={{position: 'absolute', right: 0, top: -6, cursor: 'pointer'}}
                    >
                      &times;
                    </span>
                  </span>}
                <p className={`mb-0 fs-12 work-hours 
                          ${isHoliday(dish) && props.activeCategory !== dish.id && 'red-notice'}
                          ${props.activeCategory === dish.id && 'text-white'}`}
                >
                  {working_time(dish)}
                </p>
                { props.activeCategory === dish.id &&
                <DropDown className='ml-2' fill={'white'} style={{transform: 'rotate(180deg)'}}/>}
              </div>
            </div>
            <Collapse in={props.activeCategory === dish.id} className=''
                      onEntered={() => {
                        !!refs.current[dish.id] &&
                        window.scrollTo({
                          top: refs.current[dish.id].offsetTop - (!!props.company ? 230 : 85),
                          left: 0,
                          behavior: "smooth",
                        })}
                      }
                      onExit={() => hiddenCategoryRefs.current[dish.id].style.height = 0}
            >
              <div className=''>
                { props.activeCategory === dish.id &&
                  <Category category={dish} selectedSubcategory={props.state.selectedSubcategory} refs={refs}
                          noPhoto={props.noPhoto} setState={props.setState} state={props.state}
                          handleDishOrderCount={props.handleDishOrderCount}
                          handleAddDishToOrder={props.handleAddDishToOrder}
                          selectDishVariation={props.selectDishVariation}
                          selectComplexDish={props.selectComplexDish}
                          dishParameter={props.dishParameter}
                          calculateCount={props.calculateCount}
                          table={props.table} company={props.company}
                          acceptOutsideOrders={props.acceptOutsideOrders}
                          countDishVariation={props.countDishVariation}
                          fromDashboard={props.fromDashboard}
                          restaurant={props.restaurant}/>}
              </div>
            </Collapse>
          </div>
        </Fragment>)}
    </div>
  );
};

export default EmojiView;